import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  FUNDINGSOURCE_LINKS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchFundingSourceLink = async (payload) => {
  const params = payload.payload;
  const query = generateQuery(params.currentPage);
  const sorting = params.sortParams ? params.sortParams : '&sortBy=createdAt&direction=DESC';
  if (params.filterParams && !params.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.FUNDINGSOURCE_LINK}?${params.filterParams}`);
  }
  if (params.filterParams && params.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.FUNDINGSOURCE_LINK}${query}${sorting}&${params.filterParams}`);
  }
  if (!params.filterParams && params.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.FUNDINGSOURCE_LINK}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.FUNDINGSOURCE_LINK}${query}${sorting}`);
};

const postFundingSourceLink = async (params) => axiosAuthInstance.post(API_END_POINTS.FUNDINGSOURCE_LINK, params);

export function* getFundingSourceLink(action) {
  try {
    const { data: { entity } } = yield call(fetchFundingSourceLink, action.payload);
    yield put({ type: FUNDINGSOURCE_LINKS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: FUNDINGSOURCE_LINKS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* createFundingSourceLink(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postFundingSourceLink, action.payload);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.FUNDINGSOURCELINK.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
